/**
 * 댓글 타깃.
 *
 * 2단 댓글 UI 는 원래 서베이에 묶여 있었고, 기사·공고로 일반화했다. 서베이는
 * 커뮤니티 글(post)의 부속이 되었고(2026-09-10) 댓글은 글에 달린다 —
 * 서버 계약도 같은 모양이다 (comments.post_id / article_id / grant_id).
 *
 * 타깃은 스레드가 매달리는 자원이고, 두 가지로 풀린다:
 *   - 목록 엔드포인트  (GET/POST {base}/comments)
 *   - 캐시 키          (['comments', kind, id])
 *
 * 개별 댓글 쓰기(PATCH/DELETE /comments/:id)는 타깃과 무관하다.
 */
export interface CommentTarget {
  kind: 'post' | 'article' | 'grant';
  id: string;
}

/** 타깃별 컬렉션 엔드포인트. 공고는 API 경로가 `grants` 다 — URL 은 /news 지만. */
const BASE: Record<CommentTarget['kind'], string> = {
  post: 'posts',
  article: 'articles',
  grant: 'grants',
};

/** 목록·작성 엔드포인트. */
export function commentsPath(target: CommentTarget): string {
  return `/${BASE[target.kind]}/${target.id}/comments`;
}

/** React Query 캐시 키. */
export function commentsKey(target: CommentTarget) {
  return ['comments', target.kind, target.id] as const;
}
